<div class="alignment-wrapper" [ngClass]="customClass">
  <div class="sidebar-edit-item-text comp-alignment">{{ title || "campaign.widget.sidebar.edit.text.font-alignment" | translate }}</div>
  <mat-button-toggle-group
    class="component-alignment-buttons"
    name="fontStyle"
    hideSingleSelectionIndicator="true"
    [(ngModel)]="currentAlignment"
    (change)="updateAlignment()"
    [class.disabled]="isHorizontalAlignmentDisabled"
    [disabled]="isHorizontalAlignmentDisabled"
    [matTooltip]="(isHorizontalAlignmentDisabled ? 'campaign.widget.sidebar.edit.dimensions.hints.align-disabled-horizontal' : null) | translate">
    <mat-button-toggle value="{{ TextAlignments.Left }}">
      <mat-icon>format_align_left</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="{{ TextAlignments.Center }}">
      <mat-icon>format_align_center</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="{{ TextAlignments.Right }}">
      <mat-icon>format_align_right</mat-icon>
    </mat-button-toggle>
    @if (customClass === "edit-text") {
      <mat-button-toggle value="{{ TextAlignments.Justify }}">
        <mat-icon>format_align_justify</mat-icon>
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
</div>
@if (brandSettingAlignment) {
  <app-link-to-brand-variables
    [customClass]="customClass"
    [isBrandSettingsValueApplied]="isBrandSettingsValueApplied"
    [isDefaultValue]="true"
    [disabled]="isHorizontalAlignmentDisabled"
    [brandSettingsValue]="brandSettingAlignment"
    (apply)="applyBrandSettings()"></app-link-to-brand-variables>
}
